import { IconBar, SpinningLogo } from ".";
import { IonRow } from "@ionic/react";

export const InfoBottom = (props) => {
  const { logos, project, iconsMenu, isIntroPage } = props;

  const className = "logos-info-bottom";

  if (isIntroPage) {
    return null;
  }

  return (
    <div id="InfoBottom" className="info-bottom">
      <SpinningLogo className={className} logos={logos} />
      <IconBar project={project} iconsMenu={iconsMenu} />
      <div className="credits-div">
        <IonRow className="flex-center no-padding">
          <p style={{ fontFamily: "Helvetica", fontSize: "0.8rem" }}>
            Design and development
          </p>
        </IonRow>
        <IonRow className="flex-center no-padding">
          <a
            href="https://www.linkedin.com/in/igor-morozov2000/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontFamily: "Helvetica",
              fontSize: "0.8rem",
              color: "white",
            }}
          >
            <p style={{ fontFamily: "Helvetica", fontSize: "0.8rem" }}>
              Igor Morozov
            </p>
          </a>
        </IonRow>
      </div>
    </div>
  );
};
